/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  DeactivateUsersOptions,
  DeactivateUsersStatus202,
  DeactivateUsersStatus400,
  DeactivateUsersStatus403,
  DeactivateUsersStatus404,
  DeactivateUsersStatus500,
} from '../types/DeactivateUsers'
import type { UseMutationOptions, UseMutationResult, QueryClient } from '@tanstack/react-query'
import { deactivateUsers } from '../clients/deactivateUsers'
import { mutationOptions, useMutation } from '@tanstack/react-query'

export const deactivateUsersMutationKey = () => [{ url: '/v1/user/deactivate' }] as const

export function deactivateUsersMutationOptions<TContext = unknown>(
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const mutationKey = deactivateUsersMutationKey()
  return mutationOptions<
    DeactivateUsersStatus202,
    ResponseErrorConfig<
      | DeactivateUsersStatus400
      | DeactivateUsersStatus403
      | DeactivateUsersStatus404
      | DeactivateUsersStatus500
    >,
    DeactivateUsersOptions,
    TContext
  >({
    mutationKey,
    mutationFn: async ({ body }) => {
      return deactivateUsers({ ...config, body, throwOnError: true }).unwrap()
    },
  })
}

/**
 * @description Bulk form of POST /v1/user/{user_id}/deactivate. Admin may target tenant_id, trading_challenge_id, or explicit user_ids. COMPETITION_MANAGER may only target one assigned trading_challenge_id and their users (no tenant_id). Each user is processed independently: the response reports, per user, either the accepted deactivation request or the reason it was rejected. Duplicate user IDs collapse into one result.
 * @summary Deactivate multiple users' accounts (admin or scoped competition manager)
 * {@link /v1/user/deactivate}
 */
export function useDeactivateUsers<TContext>(
  options: {
    mutation?: UseMutationOptions<
      DeactivateUsersStatus202,
      ResponseErrorConfig<
        | DeactivateUsersStatus400
        | DeactivateUsersStatus403
        | DeactivateUsersStatus404
        | DeactivateUsersStatus500
      >,
      DeactivateUsersOptions,
      TContext
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...mutationOptions } = mutation
  const mutationKey = mutationOptions.mutationKey ?? deactivateUsersMutationKey()

  const baseOptions = deactivateUsersMutationOptions(config) as UseMutationOptions<
    DeactivateUsersStatus202,
    ResponseErrorConfig<
      | DeactivateUsersStatus400
      | DeactivateUsersStatus403
      | DeactivateUsersStatus404
      | DeactivateUsersStatus500
    >,
    DeactivateUsersOptions,
    TContext
  >

  return useMutation<
    DeactivateUsersStatus202,
    ResponseErrorConfig<
      | DeactivateUsersStatus400
      | DeactivateUsersStatus403
      | DeactivateUsersStatus404
      | DeactivateUsersStatus500
    >,
    DeactivateUsersOptions,
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    DeactivateUsersStatus202,
    ResponseErrorConfig<
      | DeactivateUsersStatus400
      | DeactivateUsersStatus403
      | DeactivateUsersStatus404
      | DeactivateUsersStatus500
    >,
    DeactivateUsersOptions,
    TContext
  >
}
